import {InlineDatumReactComponentProps} from '@stripe-internal/inline-data';
import {LightCard} from '@stripe-internal/conversations-ui';
import {view} from '@sail/ui';
import {FormattedMessage, defineMessages} from 'react-intl';
import {CurrentMerchantSection} from '../helpers/CurrentMerchantSection';
import {TransactionDetailsSection} from './TransactionDetailsSection';

const messages = defineMessages({
  noTransactionSummary: {
    id: 'mse_inline_data.link_declines.no_transaction_summary',
    description: 'Message when there is not a valid transaction to display',
    defaultMessage:
      'There are no failed transactions associated with your account at this time.',
  },
});

export type TransactionDetails = {
  transaction_amount: string;
  transaction_currency: string;
  transaction_date: number;
};

export type ValueProps = {
  merchant_name?: string;
  merchant_avatar?: string;
  transaction_details?: TransactionDetails;
  decline_code?: string;
};

export const LinkDeclines = (props: InlineDatumReactComponentProps) => {
  const {datum} = props;
  const value = datum.value as ValueProps;

  const {
    merchant_name: merchantName,
    merchant_avatar: merchantAvatar,
    transaction_details: transactionDetails,
    decline_code: declineCode,
  } = value;

  return (
    <LightCard isOuter>
      <view.div
        css={{stack: 'y', gap: 'medium'}}
        data-testid="link-declines-lightcard-1"
      >
        {merchantName ? (
          <CurrentMerchantSection
            merchantName={merchantName}
            merchantAvatar={merchantAvatar}
          />
        ) : null}
        {transactionDetails ? (
          <TransactionDetailsSection
            transactionDetails={transactionDetails}
            declineCode={declineCode}
          />
        ) : (
          <view.div css={{font: 'label.medium'}}>
            <FormattedMessage {...messages.noTransactionSummary} />
          </view.div>
        )}
      </view.div>
    </LightCard>
  );
};
